<svelte:options accessors={true} />

<script>
  import { tooltip } from "$lib/utils/tooltip";
  import { cx } from "$lib/utils/cx";
  import { fade } from "svelte/transition";
  import { persisted } from "$lib/utils/persisted-stores";
  import { Icon, ClipboardDocumentCheck, PauseCircle } from "svelte-hero-icons";
  export let x = 0;
  export let y = 0;
  export let canvasWidth = 1920;
  export let canvasHeight = 1080;

  let showNormalized = true;
  let showCopied = false;
  const shouldCopyToClipboard = persisted("should_copy_coords_to_clipboard", true);
  const toggleCopyToClipboard = () => shouldCopyToClipboard.update((value) => !value);

  function toggleFormat() {
    showNormalized = !showNormalized;
  }

  export function onCopy() {
    copyToClipboard();
  }

  function copyToClipboard() {
    if (!$shouldCopyToClipboard) return;
    navigator.clipboard.writeText(`${displayX},${displayY}`);
    showCopied = true;
    setTimeout(() => {
      showCopied = false;
    }, 400);
  }

  $: displayX = showNormalized ? (x / canvasWidth).toFixed(3) : Math.round(x);
  $: displayY = showNormalized ? (y / canvasHeight).toFixed(3) : Math.round(y);
</script>

<div class="flex items-center gap-2">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    use:tooltip={{
      placement: "top",
      content: "Toggle auto-copy coordinates",
    }}
    class="cursor-pointer h-3 w-3 pb-5"
    on:click={toggleCopyToClipboard}
    role="button"
    tabindex="0"
  >
    <Icon
      src={$shouldCopyToClipboard ? ClipboardDocumentCheck : PauseCircle}
      class={cx("h-5 w-5", {
        "text-content-muted": $shouldCopyToClipboard,
        "text-red-600": !$shouldCopyToClipboard,
      })}
    />
  </div>
  <div
    use:tooltip={{
      placement: "top",
      content: showNormalized
        ? "Switch to absolute coordinates"
        : "Switch to normalized coordinates",
    }}
    class="px-2 py-1 text-xs font-mono rounded cursor-pointer flex items-center gap-1"
    on:click={toggleFormat}
    on:keydown={toggleFormat}
    role="button"
    tabindex="0"
  >
    <span class="text-content-muted">x:</span>
    {displayX}{showNormalized ? "" : "px"}
    <span class="text-content-muted">y:</span>
    {displayY}{showNormalized ? "" : "px"}
    {#if showCopied}
      <div
        out:fade={{ duration: 300 }}
        class="ml-1 bg-gray-700 text-white text-xs px-1 py-0.5 rounded"
      >
        Copied
      </div>
    {/if}
  </div>
</div>
